import Skeleton from 'react-loading-skeleton';
import { useInstanceLink } from '@/hooks/mainStore';
import useMainStore from '@/store/mainStore';

export default function Creator() {
  const studioInstance = useMainStore((store) => store.studioInstance);
  const instanceLink = useInstanceLink();

  if (!studioInstance || !studioInstance.creator || !instanceLink) {
    return (
      <div className="m-claim--flex m-claim--items-center m-claim--justify-between m-claim--gap-4">
        <div className="m-claim--flex m-claim--items-center m-claim--gap-4">
          {/* Avatar */}
          <Skeleton
            circle
            width={40}
            height={40}
          />
          {/* Name and handle */}
          <div className="m-claim--flex m-claim--flex-col m-claim--gap-2">
            <Skeleton width={120} />
            <Skeleton width={80} />
          </div>
        </div>
        {/* Subscribe button */}
        <Skeleton
          width={100}
          height={36}
        />
      </div>
    );
  }

  return (
    <div
      data-widget="m-wallet-identity"
      data-workspace={studioInstance?.creator?.id}
      data-subscribe-link={`${instanceLink}?utm_source=subscribed_tweet`}
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className="manifold-scheme-dark"
    />
  );
}
